export function convertDoubleToDuration (cellValue: number): string {
    // Define conversion constants
    const minutesInYear = 60 * 24 * 365;
    const minutesInMonth = 60 * 24 * 30;
    const minutesInDay = 60 * 24;
    const minutesInHour = 60;

    // Calculate the total number of minutes
    let minutes = cellValue * 60;

    // Create an array of time frame strings
    const timeFrames = [];

    // Calculate the total number of days, months, and years
    const years = minutes / minutesInYear;
    if (years >= 1) {
        timeFrames.push(`${Math.floor(years)}yr`);
        minutes -= Math.floor(years) * minutesInYear;
    }
    const months = minutes / minutesInMonth;
    if (months >= 1) {
        timeFrames.push(`${Math.floor(months)}mo`);
        minutes -= Math.floor(months) * minutesInMonth;
    }

    const days = minutes / minutesInDay;
    if (days >= 1) {
        timeFrames.push(`${Math.floor(days)}d`);
        minutes -= Math.floor(days) * minutesInDay;
    }

    const hours = minutes / minutesInHour;
    if (hours >= 1) {
        minutes -= Math.floor(hours) * minutesInHour;
        if (timeFrames.length < 3) {
            timeFrames.push(`${Math.floor(hours)}hr`);
        }
    }

    if (minutes > 0 && timeFrames.length < 3) {
        timeFrames.push(`${Math.floor(minutes)}m`);
    }
    const output = timeFrames.slice(0, 3).join(' ');

    return output;
}
